module.exports = __webpack_public_path__ + "img/icon-chip.2886eb66.png";